// src/components/ChatInput.js
import React from "react";
import { Box, TextField, InputAdornment, IconButton } from "@mui/material";
import ArrowCircleUpSharpIcon from "@mui/icons-material/ArrowCircleUpSharp";
import StopCircleOutlinedIcon from "@mui/icons-material/StopCircleOutlined";
import "../../styles/Betsy.css";
import ClearIcon from "@mui/icons-material/Clear";

const ChatInput = ({ input, setInput, onSend, isTyping }) => {
  const handleSend = () => {
    if (input.trim() && !isTyping) {
      onSend(input);
      setInput("");
    }
  };

  return (
    <Box className="chat-input-field">
      <TextField
        fullWidth
        placeholder="Ask anything..."
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSend()}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {input && (
                <IconButton onClick={() => setInput("")} edge="end">
                  <ClearIcon sx={{ color: "#fff" }} />
                </IconButton>
              )}

              {isTyping ? (
                <IconButton                  
                  edge="end"
                  color="primary"
                  disabled={isTyping}
                >
                  <StopCircleOutlinedIcon sx={{ color: "#fff" }} />
                </IconButton>
              ) : (
                <IconButton
                  onClick={handleSend}
                  edge="end"
                  color="primary"                  
                >
                  <ArrowCircleUpSharpIcon sx={{ color: "#fff" }} />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
        sx={{
          backgroundColor: "#303030",
          border: "1px solid #aaa",
          borderRadius: "25px",
          "& .MuiOutlinedInput-root": {
            borderRadius: "25px",
          },
          "& .MuiInputBase-input": {
            color: "#fff",
            fontFamily: '"JetBrains Mono", monospace',
          },
          "& .MuiInputBase-input::placeholder": {
            color: "gray",
            opacity: 1,
          },
        }}
      />
      <p className="helpertext1">
        * BETSY can make mistakes, please check and validate responses. ©
        Copyright 2026. All Rights Reserved.
        <br />
        <span className="helpertext2">
          BETSY is currently being trained on UTahData.org data
        </span>
      </p>
    </Box>
  );
};

export default ChatInput;
